import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout-only route — the hub lives in `bn.services.index.tsx`.
export const Route = createFileRoute("/bn/services")({
  component: () => <Outlet />,
});
